var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loja-perfeita-list-skeleton",attrs:{"role":"status","aria-live":"polite"}},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.screenReaderText))]),_c('b-skeleton-table',{attrs:{"rows":_vm.rows,"columns":_vm.columns,"table-props":{ striped: true, hover: true }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }